import _typeof from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/typeof.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useRef, useEffect } from "react";
import { get, isEmpty } from "lodash";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
var AiMultipleDropdown = function AiMultipleDropdown(_ref) {
  var placeholder = _ref.placeholder,
    options = _ref.options,
    onChange = _ref.onChange,
    selectedOptions = _ref.selectedOptions,
    _ref$labelMappings = _ref.labelMappings,
    labelMappings = _ref$labelMappings === void 0 ? {} : _ref$labelMappings,
    _ref$tagsList = _ref.tagsList,
    tagsList = _ref$tagsList === void 0 ? {} : _ref$tagsList,
    category = _ref.category,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$workspaceData = _ref.workspaceData,
    workspaceData = _ref$workspaceData === void 0 ? [] : _ref$workspaceData,
    _ref$showAdminTagOnly = _ref.showAdminTagOnly,
    showAdminTagOnly = _ref$showAdminTagOnly === void 0 ? false : _ref$showAdminTagOnly,
    _ref$skipPermissionCh = _ref.skipPermissionCheck,
    skipPermissionCheck = _ref$skipPermissionCh === void 0 ? false : _ref$skipPermissionCh,
    _ref$showUserRolePill = _ref.showUserRolePill,
    showUserRolePill = _ref$showUserRolePill === void 0 ? true : _ref$showUserRolePill,
    _ref$optionsListClass = _ref.optionsListClassName,
    optionsListClassName = _ref$optionsListClass === void 0 ? "" : _ref$optionsListClass;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  var dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      return document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  var handleToggle = function handleToggle() {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };
  var handleOptionClick = function handleOptionClick(optionValue) {
    var _optionValue = optionValue.trim();
    if (disabled) return;
    var newSelectedOptions = selectedOptions.includes(_optionValue) ? selectedOptions.filter(function (value) {
      return value !== _optionValue;
    }) : [].concat(_toConsumableArray(selectedOptions), [_optionValue]);
    onChange(newSelectedOptions);
  };
  var getDisplayText = function getDisplayText() {
    if (isEmpty(selectedOptions)) {
      return placeholder;
    }
    return selectedOptions.map(function (opt_) {
      var opt = opt_;
      if (category === "symptoms" || category === "risk_groups") {
        var tags = get(tagsList, ["qxr", category, category], []);
        tags.forEach(function (tag) {
          if (tag.id === opt_) opt = tag.choice;
        });
      }
      return labelMappings[opt] || opt;
    }).join(", ");
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: dropdownRef,
    className: classNames("relative", {
      "opacity-50": disabled
    })
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleToggle,
    disabled: disabled,
    className: classNames("relative border border-gray-600 rounded-6 w-full bg-transparent flex items-center px-5 py-3 pr-7", {
      "border-b-gray-100 dark:bg-gray-900 rounded-b-none": isOpen,
      "cursor-not-allowed": disabled
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "sm:text-[12px] truncate text-left flex-1"
  }, getDisplayText()), /*#__PURE__*/React.createElement("svg", {
    className: classNames("ml-auto absolute top-1/2 -translate-y-1/2 right-2 transition-transform", {
      "rotate-180": isOpen
    }),
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 9L12 15L6 9",
    stroke: "#474F58",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), isOpen && !disabled && /*#__PURE__*/React.createElement("div", {
    className: classNames("absolute top-full z-10 w-full py-3 space-y-2 border border-t-0 border-gray-600 bg-gray-100 dark:bg-gray-800 rounded-6 rounded-t-none overflow-hidden max-h-[200px] overflow-y-auto scrollbar-light", optionsListClassName)
  }, options.map(function (opt_) {
    var _optDetails2;
    var opt;
    if (_typeof(opt_) === "object") {
      opt = opt_.choice || "";
    } else {
      opt = opt_;
    }
    var optionDisabled = false;
    var optDetails;
    if (!isEmpty(workspaceData)) {
      optDetails = workspaceData.find(function (data) {
        return data.uuid === opt;
      });
      if (!skipPermissionCheck) {
        var _optDetails;
        optionDisabled = !((_optDetails = optDetails) !== null && _optDetails !== void 0 && _optDetails.has_permission);
      }
    }
    var role = optDetails ? t("user_roles.".concat(optDetails.role)) : "";
    if (showAdminTagOnly && ((_optDetails2 = optDetails) === null || _optDetails2 === void 0 ? void 0 : _optDetails2.role) !== "admin") {
      role = "";
    }
    var optionValue = _typeof(opt_) === "object" ? opt_.id || opt : opt;
    var isSelected = selectedOptions.includes(optionValue === null || optionValue === void 0 ? void 0 : optionValue.trim());
    return /*#__PURE__*/React.createElement("div", {
      key: opt,
      onClick: function onClick() {
        return !optionDisabled && handleOptionClick(optionValue);
      },
      className: classNames("cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-200 px-3 py-2", {
        "hover:!bg-transparent dark:hover:!bg-transparent !cursor-not-allowed opacity-50": optionDisabled
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center space-x-3"
    }, /*#__PURE__*/React.createElement("span", {
      className: "flex items-center"
    }, isSelected ? /*#__PURE__*/React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M3 1C1.89688 1 1 1.89688 1 3V13C1 14.1031 1.89688 15 3 15H13C14.1031 15 15 14.1031 15 13V3C15 1.89688 14.1031 1 13 1H3ZM11.5313 6.53125L7.53125 10.5312C7.2375 10.825 6.7625 10.825 6.47188 10.5312L4.47188 8.53125C4.17813 8.2375 4.17813 7.7625 4.47188 7.47188C4.76563 7.18125 5.24063 7.17813 5.53125 7.47188L7 8.94063L10.4688 5.46875C10.7625 5.175 11.2375 5.175 11.5281 5.46875C11.8188 5.7625 11.8219 6.2375 11.5281 6.52813L11.5313 6.53125Z",
      fill: "#00A9A7"
    })) :
    /*#__PURE__*/
    /* Unselected Checkbox */
    React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M1 3C1 1.89531 1.89531 1 3 1H13C14.1031 1 15 1.89531 15 3V13C15 14.1031 14.1031 15 13 15H3C1.89531 15 1 14.1031 1 13V3ZM2.5 3V13C2.5 13.275 2.72375 13.5 3 13.5H13C13.275 13.5 13.5 13.275 13.5 13V3C13.5 2.72375 13.275 2.5 13 2.5H3C2.72375 2.5 2.5 2.72375 2.5 3Z",
      fill: "#9EA3A8"
    }))), /*#__PURE__*/React.createElement("span", {
      className: "whitespace-nowrap"
    }, labelMappings[opt] || opt), showUserRolePill && role && /*#__PURE__*/React.createElement("span", {
      className: "px-2 text-md py-0.5 bg-gray-600 !text-gray-100 rounded-md"
    }, role), optionDisabled && /*#__PURE__*/React.createElement("span", {
      className: "whitespace-nowrap flex-1 text-right text-md"
    }, t("no_access"))));
  })));
};
export default AiMultipleDropdown;